import * as React from "react";

const SvgComponent = ({ width = "16px", height = "16px", color = "#000" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    className="time-icon"
  >
    <path
      d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm0 1.185A6.806 6.806 0 0 1 14.815 8 6.806 6.806 0 0 1 8 14.815 6.806 6.806 0 0 1 1.185 8 6.806 6.806 0 0 1 8 1.185Zm0 1.778a.593.593 0 0 0-.593.592V8c0 .219.12.407.297.51 1.105.637 2.224 1.284 3.333 1.925.284.164.651.07.815-.213a.59.59 0 0 0-.222-.806L8.593 7.657V3.555A.593.593 0 0 0 8 2.963Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
